import { Component, Input, OnInit } from '@angular/core';

import { AccountService } from 'src/app/shared/services/account.service';

@Component({
  selector: 'app-notice',
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss'],
})
export class NoticeComponent implements OnInit {
  @Input()
  public load = false;

  @Input()
  public message: string | null = null;

  constructor(
    private accountService: AccountService) {}

  async ngOnInit() {
    if (this.load) {
      this.fetch();
    }
  }

  async fetch() {
    const notice = await this.accountService
      .getIsEventProcessingSlow()
      .catch(() => null);

    if (notice?.slow ?? false) {
      this.message = (
        'Event processing is slow due to a high number of requests. '
        + 'No data will be lost and numbers will be updated at a later '
        + 'point. We apologise for the inconvenience.'
      );
    }
  }
}
